import { useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { fmtDate } from "../lib/format";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";

export default function DeleteEntryDialog({ entry, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await api.delete(`/entries/${entry.id}`, { params: { reason } });
      toast.success("Entry deleted");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader><DialogTitle className="text-red-700">Delete entry for {fmtDate(entry.date)}?</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">This removes your sales, walk-ins and bills for this day from all your KPIs. The day will show as pending again.</p>
        <Textarea placeholder="Reason (required)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="delete-entry-reason-input" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="delete-entry-cancel-button">Cancel</Button>
          <Button disabled={busy || !reason.trim()} onClick={run} className="bg-red-700 hover:bg-red-800" data-testid="delete-entry-confirm-button">Delete entry</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
